import {
    Box, Text, Modal, ModalBody, ModalCloseButton,
    ModalContent, ModalHeader, ModalOverlay, Button, Flex, useTheme
} from '@chakra-ui/react'
import React from 'react'
import { Theme } from '../theme'

type LogoutModalPropType = {
    isOpen: boolean,
    onClose: () => void,
    onYesButtonClick: () => void
    logoutButtonLoading: boolean
}

const LogoutModal = ({ isOpen, onClose, onYesButtonClick, logoutButtonLoading }: LogoutModalPropType) => {
    const theme = useTheme<Theme>()
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick={true}
            isCentered={true}
            size="md"
            returnFocusOnClose={false}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader />
                <ModalCloseButton
                    borderRadius={"50%"}
                    bg={theme.colors.bg.paper}
                    top={"2.5em"}
                    right={"1em"}
                    transform={"translate(-100%)"}
                    w="2.5em"
                    h="2.5em"
                />
                <ModalBody borderRadius={"4px"}>
                    <Box my="2em" mx="1em">
                        <Box mb="2em">
                            <Text
                                fontSize={"1.5em"}
                                fontWeight={500}
                                lineHeight={1.3}
                                fontFamily="Inter"
                            >
                                Are you sure you want to logout?
                            </Text>
                        </Box>
                        <Flex gap={"1em"}>
                            <Button
                                w="100%"
                                h="3em"
                                color={"white"}
                                bg={theme.colors.success}
                                borderRadius={"4px"}
                                _hover={{ bg: theme.colors.success }}
                                isLoading={logoutButtonLoading}
                                onClick={onYesButtonClick}
                            >
                                Yes
                            </Button>
                            <Button
                                w="100%"
                                h="3em"
                                color={"white"}
                                bg={theme.colors.error}
                                borderRadius={"4px"}
                                _hover={{ bg: theme.colors.error }}
                                onClick={onClose}
                            >
                                No
                            </Button>
                        </Flex>
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default LogoutModal